import { useTranslation } from "react-i18next";
import { type AgendaStatus } from "@/lib/hooks/use-upcoming-agenda";

const TONES: Record<AgendaStatus, string> = {
  // Green: settled, nothing to do.
  confirmed: "bg-success-100/10 text-success-120",
  // Amber: you did your part, they have not answered.
  applied: "bg-warning-100/10 text-warning-120",
};

/**
 * The status label that used to be a tab. Two colours, and one line of copy underneath saying which
 * way the ball is rolling, because the words alone ("Aangemeld" vs "Bevestigd") are not
 * distinguishable at a glance.
 *
 * Er was een derde: "Uitgenodigd", rood, de enige die een taak was. Uitnodigingen liepen via
 * campagnes en zijn met het communicatieblok verdwenen.
 */
export function AgendaStatusBadge({ status }: { status: AgendaStatus }) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ${TONES[status]}`}
      >
        {t(`routes:upcoming-shifts.status.${status}.label`)}
      </span>
      <span className="text-sm leading-[1.4] text-txt-tertiary">
        {t(`routes:upcoming-shifts.status.${status}.hint`)}
      </span>
    </div>
  );
}
